<a
    mat-icon-button
    class="relative"
    [matTooltip]="accessibilityLabel()"
    [routerLink]="['/actions']"
    [attr.aria-label]="accessibilityLabel()">
    @if (outstandingCount() > 0) {
        <span class="absolute top-0 left-0 right-0 flex items-center justify-center h-3">
            <span
                class="ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-red-600 px-1 text-xs font-medium text-white">
                {{ badgeLabel() }}
            </span>
        </span>
    }
    <mat-icon [svgIcon]="'heroicons_outline:bolt'"></mat-icon>
</a>
